import { useEffect, useState } from "react"
import { getMyPlanIntegrations } from "../api/requests/subscription-requests"

/**
 * Firmanın paketinde açık olan entegrasyonlar (sanal POS + muhasebe).
 *
 * Entegrasyon kartlarını kilitlemek için kullanılır. **Güvenlik sınırı değildir** —
 * asıl reddetme backend'deki `PlanIntegrationInterceptor` tarafından yapılır (403).
 * Buradaki amaç kullanıcıya, kaydedemeyeceği bir formu doldurtmamak.
 *
 * Hata/yükleniyor durumunda `loaded=false` kalır ve `has()` **true** verir: liste
 * alınamadı diye çalışan bir entegrasyonu kilitlemek kullanıcıyı sebepsiz durdurur.
 */
export const usePlanIntegrations = () => {
  const [integrations, setIntegrations] = useState([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const res = await getMyPlanIntegrations()
        if (!cancelled) {
          setIntegrations(res?.data || [])
          setLoaded(true)
        }
      } catch {
        if (!cancelled) setIntegrations([])
      }
    })()
    return () => { cancelled = true }
  }, [])

  /** Entegrasyon paket kapsamında mı. Kod yoksa (backend'i olmayan sağlayıcı) kilitlenmez. */
  const has = (code) => {
    if (!loaded) return true
    if (!code) return true
    return integrations.includes(code)
  }

  return { integrations, loaded, has }
}

export default usePlanIntegrations
